import './App.scss';
import {BrowserRouter, Route} from 'react-router-dom';
import Home from './component/pages/Home';

const App = () => {
  return (
    <div className="app-container">
    <BrowserRouter>
      <Home />
    </BrowserRouter>
    </div>
  );
}

export default App;
